import React from 'react';
import {
  Modal,
  Card,
  useMediaQuery,
  Theme,
} from '@mui/material';
import { NewPatientModalContent } from './NewPatientModalContent';

interface NewPatientModalProps {
  open: boolean;
  onClose: () => void;
  onSuccessfulSubmission: (patientId: string) => void;
  simplifiedView?: boolean;
  initialName?: string;
  source?: string;
}

/**
 * Legacy wrapper for NewPatientModal
 * This component maintains backward compatibility for existing usage
 * while using the extracted NewPatientModalContent
 */
const NewPatientModal: React.FC<NewPatientModalProps> = ({
  open,
  onClose,
  onSuccessfulSubmission,
  simplifiedView = false,
  initialName,
  source = 'unknown',
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Modal open={open} onClose={onClose}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isMobile ? '95%' : '80%',
          maxWidth: 600,
          maxHeight: '90%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <NewPatientModalContent
          onClose={onClose}
          onSuccessfulSubmission={onSuccessfulSubmission}
          simplifiedView={simplifiedView || isMobile}
          initialName={initialName}
          source={source}
          isOpen={open}
        />
      </Card>
    </Modal>
  );
};

export default NewPatientModal;